module.exports = __webpack_public_path__ + "static/media/meme.1d0e912c.jpg";